import clsx from 'clsx';

import { Icon } from '@trend-dev/ui-libs-icons';

import styles from '../../styles.module.scss';

export const listDesktop = [
    {
        content: (
            <div className={clsx(styles.contentDesktop, styles.center)}>
                Чтобы предоставить доступы, в&nbsp;настройках своего браузера разрешите сайту meetings.trendrealty.ru использовать микрофон / камеру
            </div>
        ),
        mark: <Icon name='Lock_20' />,
    },
];

export const listMobile = [
    {
        content: (
            <div className={styles.contentMobile}>
                Чтобы предоставить доступы, в&nbsp;настройках своего браузера разрешите сайту meetings.trendrealty.ru использовать микрофон&nbsp;/
                камеру
            </div>
        ),
        mark: <Icon name='Lock_20' />,
    },
];
